import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@freighthub/silhouette-core'
import { inject, observer } from 'mobx-react'
import { Component, FC } from 'react'
import { UIStore } from 'service/UIStore'

const DefaultAction: FC<{ onClick: () => void }> = (props) => (
  <Button
    action={(actions) => {
      // https://material-ui.com/api/button-base/
      // TODO: Remove timeout by upgrading to new MUI version
      // https://github.com/mui/material-ui/issues/30953
      if (actions) {
        setTimeout(() => actions.focusVisible(), 100)
      }
    }}
    onClick={props.onClick}
  >
    OK
  </Button>
)

@inject('uiStore')
@observer
export class FhDialog extends Component<{
  uiStore?: UIStore
}> {
  render() {
    // @ts-expect-error TS(2339) FIXME: Property 'dialog' does not exist on type 'UIStore ... Remove this comment to see the full error message
    const { dialog } = this.props.uiStore
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    const actions = dialog.actions || <DefaultAction onClick={this.props.uiStore.dialog.hide} />
    return (
      <Dialog open={dialog.open} onClose={dialog.hide}>
        <DialogTitle>{dialog.title}</DialogTitle>
        <DialogContent style={dialog.contentStyle}>
          <DialogContentText>{dialog.content}</DialogContentText>
        </DialogContent>
        <DialogActions>{actions}</DialogActions>
      </Dialog>
    )
  }
}
